import {
    StrollerAllReviewsPhotosState,
    StrollersAllReviewsPhotosState,
    initialStrollerAllReviewsPhotosState,
    initialStrollersAllReviewsPhotosState,
} from "@/mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotos.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollersAllReviewsPhotosState = (
    state: AppState,
): StrollersAllReviewsPhotosState =>
    state.containers.strollers.strollersAllReviewsPhotos || initialStrollersAllReviewsPhotosState;

export const getStrollerAllReviewsPhotosState = (
    state: AppState,
    strollerSlug: string,
): StrollerAllReviewsPhotosState =>
    getStrollersAllReviewsPhotosState(state).pages[strollerSlug] ||
    initialStrollerAllReviewsPhotosState;
